export function stripHtml(value = "") {
  return String(value)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", max = 180) {
  const clean = stripHtml(value);

  if (clean.length <= max) return clean;

  return `${clean.slice(0, max - 1)}…`;
}

export function formatDateTime(value) {
  if (!value) return "Date inconnue";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "Date inconnue";

  return date.toLocaleString("fr-FR", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function formatShortDate(value) {
  if (!value) return "—";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) return "—";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function getNewsStatusMeta(isActive) {
  if (isActive) {
    return {
      label: "Publiée",
      shortLabel: "Actif",
      className:
        "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    };
  }

  return {
    label: "Brouillon",
    shortLabel: "Inactif",
    className:
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
  };
}

export function buildNewsSearchParams({ q, activeFilter, page, limit }) {
  return {
    q: q?.trim() || undefined,
    is_active:
      activeFilter === "all"
        ? undefined
        : activeFilter === "active"
          ? true
          : false,
    page,
    limit,
    sort: "created_at",
    dir: "DESC",
  };
}

export function normalizeNewsForm(form) {
  return {
    title: form.title.trim(),
    content: form.content,
    image_url: form.image_url?.trim() || null,
    is_active: !!form.is_active,
  };
}

export function validateNewsForm(form) {
  const errors = {};

  if (!form.title?.trim()) {
    errors.title = "Le titre est obligatoire.";
  }

  if (!form.content?.trim()) {
    errors.content = "Le contenu est obligatoire.";
  }

  return errors;
}

export function getNewsStats(items = [], total = 0) {
  const activeOnPage = items.filter((item) => !!item.is_active).length;
  const inactiveOnPage = items.filter((item) => !item.is_active).length;
  const withImageOnPage = items.filter((item) => !!item.image_url).length;

  return {
    total,
    activeOnPage,
    inactiveOnPage,
    withImageOnPage,
  };
}